import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

export interface DropdownMenuItem {
  key: string;
  label: string;
  secondaryText?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}

interface DropdownMenuProps {
  trigger: React.ReactNode;
  items: DropdownMenuItem[];
}

export function DropdownMenu({ trigger, items }: DropdownMenuProps) {
  return (
    <DropdownMenuPrimitive.Root>
      <DropdownMenuPrimitive.Trigger asChild>
        {trigger}
      </DropdownMenuPrimitive.Trigger>
      <DropdownMenuPrimitive.Portal>
        <DropdownMenuPrimitive.Content
          align="end"
          sideOffset={4}
          className="z-50 min-w-[180px] overflow-hidden rounded-md border border-gray-200 bg-white p-1 shadow-md animate-in fade-in-0 zoom-in-95"
        >
          {items.map((item) => (
            <DropdownMenuPrimitive.Item
              key={item.key}
              onClick={item.onClick}
              className="flex items-center gap-2 rounded px-3 py-2 text-sm text-gray-700 cursor-pointer select-none hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
            >
              {item.icon && <span className="shrink-0">{item.icon}</span>}
              <div className="flex flex-col">
                <span>{item.label}</span>
                {item.secondaryText && (
                  <span className="text-xs text-gray-500">{item.secondaryText}</span>
                )}
              </div>
            </DropdownMenuPrimitive.Item>
          ))}
        </DropdownMenuPrimitive.Content>
      </DropdownMenuPrimitive.Portal>
    </DropdownMenuPrimitive.Root>
  );
}
